'use strict';

var _ = require('lodash');
function AdjustDatesPanelController($scope, momentService, saveAdjustmentsService, alignFaresService, dataTransformerService, dataUtilService, saveAdjustedFaresService, FaresOptimizerConstants) {
  $scope.disabledAdjustment = false;
  $scope.disabledRule = false;
  $scope.adjustedDatesOptions = saveAdjustedFaresService.getAdjustedDatesOptions();
  $scope.resetAdjustments = function () {
    delete $scope.recommendationEntry._userAdjustedDates;
  };
  $scope.transformAdjustedDatesForAlign = function (recommendationEntryData, userAdjustedDates) {
    if (!recommendationEntryData) {
      return false;
    }
    $scope.disabledAdjustment = !(recommendationEntryData.status === 'New' || recommendationEntryData.status === 'Pending' || recommendationEntryData.status === 'No Recom') || recommendationEntryData.isAlignSaveAdjustmentEnabled;
    $scope.disabledRule = recommendationEntryData.isRuleUpdated === undefined || recommendationEntryData.isRuleUpdated === false;
    var _userAdjustedDates = saveAdjustedFaresService.getUserAdjustedDatesRequiredFields();
    var groupedRow = recommendationEntryData.groupedRows[0];
    var adjustedDates = userAdjustedDates || recommendationEntryData.userAdjustedDates || groupedRow.userAdjustedDates || groupedRow;
    _userAdjustedDates.ticketingDates = _userAdjustedDates.ticketingDates.concat(getAdjustedDatesData(adjustedDates, 'ticketingDates', $scope.adjustedDatesOptions, groupedRow.rbd));
    _userAdjustedDates.reservationDates = _userAdjustedDates.reservationDates.concat(getAdjustedDatesData(adjustedDates, 'reservationDates', $scope.adjustedDatesOptions, groupedRow.rbd));
    _userAdjustedDates.outboundSeasons = _userAdjustedDates.outboundSeasons.concat(getAdjustedDatesData(adjustedDates, 'outboundSeasons', $scope.adjustedDatesOptions, groupedRow.rbd));
    _userAdjustedDates.inboundSeasons = _userAdjustedDates.inboundSeasons.concat(getAdjustedDatesData(adjustedDates, 'inboundSeasons', $scope.adjustedDatesOptions, groupedRow.rbd));
    _userAdjustedDates.outboundBlackouts = _userAdjustedDates.outboundBlackouts.concat(getAdjustedDatesData(adjustedDates, 'outboundBlackouts', $scope.adjustedDatesOptions, groupedRow.rbd));
    _userAdjustedDates.inboundBlackouts = _userAdjustedDates.inboundBlackouts.concat(getAdjustedDatesData(adjustedDates, 'inboundBlackouts', $scope.adjustedDatesOptions, groupedRow.rbd));
    _userAdjustedDates.outboundTravelDates = _userAdjustedDates.outboundTravelDates.concat(getAdjustedDatesData(adjustedDates, 'outboundTravelDates', $scope.adjustedDatesOptions, groupedRow.rbd));
    _userAdjustedDates.inboundTravelDates = _userAdjustedDates.inboundTravelDates.concat(getAdjustedDatesData(adjustedDates, 'inboundTravelDates', $scope.adjustedDatesOptions, groupedRow.rbd));
    _userAdjustedDates.inboundDaysOfWeek = _userAdjustedDates.inboundDaysOfWeek = getDOWInNumberFormat(recommendationEntryData.inboundDow);
    _userAdjustedDates.outboundDaysOfWeek = _userAdjustedDates.outboundDaysOfWeek = getDOWInNumberFormat(recommendationEntryData.dow);
    $scope.recommendationEntry._userAdjustedDates = _userAdjustedDates;
  };
  $scope.transformAdjustedDates = function (recommendationEntryData) {
    if (!recommendationEntryData) {
      return false;
    }
    $scope.disabledAdjustment = !(recommendationEntryData.status === 'New' || recommendationEntryData.status === 'Pending' || recommendationEntryData.status === 'No Recom') || recommendationEntryData.isAlignSaveAdjustmentEnabled;
    $scope.disabledRule = recommendationEntryData.isRuleUpdated === undefined || recommendationEntryData.isRuleUpdated === false;
    var _userAdjustedDates = saveAdjustedFaresService.getUserAdjustedDatesRequiredFields();
    _.map(recommendationEntryData.groupedRows, function (groupedRow) {
      if (recommendationEntryData.hostHighestFbc !== groupedRow.fbc && !_.isEmpty(groupedRow.selectedCompetitorKey)) {
        var adjustedDates = groupedRow.userAdjustedDates || groupedRow;
        _userAdjustedDates.ticketingDates = _userAdjustedDates.ticketingDates.concat(getAdjustedDatesData(adjustedDates, 'ticketingDates', $scope.adjustedDatesOptions, groupedRow.rbd));
        _userAdjustedDates.reservationDates = _userAdjustedDates.reservationDates.concat(getAdjustedDatesData(adjustedDates, 'reservationDates', $scope.adjustedDatesOptions, groupedRow.rbd));
        _userAdjustedDates.outboundSeasons = _userAdjustedDates.outboundSeasons.concat(getAdjustedDatesData(adjustedDates, 'outboundSeasons', $scope.adjustedDatesOptions, groupedRow.rbd));
        _userAdjustedDates.inboundSeasons = _userAdjustedDates.inboundSeasons.concat(getAdjustedDatesData(adjustedDates, 'inboundSeasons', $scope.adjustedDatesOptions, groupedRow.rbd));
        _userAdjustedDates.outboundBlackouts = _userAdjustedDates.outboundBlackouts.concat(getAdjustedDatesData(adjustedDates, 'outboundBlackouts', $scope.adjustedDatesOptions, groupedRow.rbd));
        _userAdjustedDates.inboundBlackouts = _userAdjustedDates.inboundBlackouts.concat(getAdjustedDatesData(adjustedDates, 'inboundBlackouts', $scope.adjustedDatesOptions, groupedRow.rbd));
        _userAdjustedDates.outboundTravelDates = _userAdjustedDates.outboundTravelDates.concat(getAdjustedDatesData(adjustedDates, 'outboundTravelDates', $scope.adjustedDatesOptions, groupedRow.rbd));
        _userAdjustedDates.inboundTravelDates = _userAdjustedDates.inboundTravelDates.concat(getAdjustedDatesData(adjustedDates, 'inboundTravelDates', $scope.adjustedDatesOptions, groupedRow.rbd));
        _userAdjustedDates.inboundDaysOfWeek = _userAdjustedDates.inboundDaysOfWeek = getDOWInNumberFormat(recommendationEntryData.inboundDow);
        _userAdjustedDates.outboundDaysOfWeek = _userAdjustedDates.outboundDaysOfWeek = getDOWInNumberFormat(recommendationEntryData.dow);
      }
    });
    $scope.recommendationEntry._userAdjustedDates = _userAdjustedDates;
  };
  $scope.cancelAdjustments = function () {
    $scope.recommendationEntry.data.showAdjustDates = false;
  };
  $scope.saveAdjustments = function () {
    $scope.regularFbcFareLadder = saveAdjustmentsService.getRegularFbcsFromFareLadder($scope.recommendationEntry.hostLadder);
    var clonedHostLadder = _.map($scope.regularFbcFareLadder, function (hostFare) {
      return {
        market: hostFare.market,
        rbd: hostFare.rbd,
        rbdLabel: getRbdLabel(hostFare),
        fbc: hostFare.fbc,
        isMappedRbd: hostFare.isMappedRbd,
        useForLadderGenerationInd: hostFare.useForLadderGenerationInd,
        rbdLabelCustomClass: saveAdjustmentsService.getCustomRbdLabelCustomClass(hostFare),
        effectiveTotalFare: hostFare.effectiveTotalFare,
        recommendedTotalFare: hostFare.recommendedTotalFare,
        minFareThreshold: alignFaresService.getTotalFareThreshold(hostFare.minFareThreshold, hostFare, hostFare.benchmarkFareComponent),
        maxFareThreshold: alignFaresService.getTotalFareThreshold(hostFare.maxFareThreshold, hostFare, hostFare.benchmarkFareComponent),
        sponsorMarketFbc: hostFare.sponsorMarketFbc,
        dualRbdSponsorFbc: hostFare.dualRbdSponsorFbc,
        percentageLinkageFactor: hostFare.percentageLinkageFactor,
        absoluteLinkageFactor: hostFare.absoluteLinkageFactor,
        effFareClass: 'fare-value effective-fare-section',
        benchmarkFareComponent: hostFare.benchmarkFareComponent,
        yq: hostFare.yq,
        yr: hostFare.yr,
        sixH: hostFare.sixH,
        sixI: hostFare.sixI,
        sixJ: hostFare.sixJ,
        sixK: hostFare.sixK,
        q: hostFare.q,
        airportTax: hostFare.airportTax,
        variable: hostFare.variable
      };
    });
    clonedHostLadder.alignedWith = $scope.recommendationEntry.hostLadder.alignedWith;
    clonedHostLadder.competitorHostCarrier = $scope.recommendationEntry.hostLadder.competitorHostCarrier;
    clonedHostLadder.competitorCarrier = $scope.recommendationEntry.hostLadder.competitorCarrier;
    clonedHostLadder.competitorFbc = $scope.recommendationEntry.hostLadder.competitorFbc;
    clonedHostLadder.competitorOrigin = $scope.recommendationEntry.hostLadder.competitorOrigin;
    clonedHostLadder.competitorDestination = $scope.recommendationEntry.hostLadder.competitorDestination;
    clonedHostLadder.competitorTariffCode = $scope.recommendationEntry.hostLadder.competitorTariffCode;
    clonedHostLadder.competitorRoutingNumber = $scope.recommendationEntry.hostLadder.competitorRoutingNumber;
    clonedHostLadder.competitorFootnote = $scope.recommendationEntry.hostLadder.competitorFootnote;
    clonedHostLadder.competitorFareSource = $scope.recommendationEntry.hostLadder.competitorFareSource;
    saveAdjustmentsService.saveAdjustments(clonedHostLadder, $scope.recommendationEntry, $scope.screenState).then(function (alignedLadder) {
      var transformedLadder = _.first(dataTransformerService.transformRecommendationLadder(alignedLadder));
      clonedHostLadder = saveAdjustedFaresService.getHostLadderData(transformedLadder.groupedRows, clonedHostLadder);
      setTotalFareThreshold(clonedHostLadder);
      var selectedHostLadderData = $scope.screenState.recommendationDetailsPanel.selectedHostLadder;
      var fareLaddersInGroup = $scope.screenState.recommendationDetailsPanel.contextData.fareLaddersInGroup;
      saveAdjustedFaresService.updateGroupedRowsFares(transformedLadder, $scope.recommendationEntry, selectedHostLadderData, clonedHostLadder, fareLaddersInGroup);
      $scope.recommendationEntry.data.userAdjustedDates = _.get(transformedLadder, 'userAdjustedDates', null);
      transformDates($scope.recommendationEntry.data);
      $scope.recommendationEntry.data.showAdjustDates = false;
    });
  };
  function getRbdLabel(hostFare) {
    var rbdLabel = hostFare.rbd;
    return hostFare.useForLadderGenerationInd === false ? rbdLabel + '*' : rbdLabel;
  }
  function setTotalFareThreshold(clonedHostLadder) {
    _.forEach(clonedHostLadder, function (hostLadderEntry) {
      hostLadderEntry.minFareThreshold = alignFaresService.getTotalFareThreshold(hostLadderEntry.minFareThreshold, hostLadderEntry, hostLadderEntry.benchmarkFareComponent);
      hostLadderEntry.maxFareThreshold = alignFaresService.getTotalFareThreshold(hostLadderEntry.maxFareThreshold, hostLadderEntry, hostLadderEntry.benchmarkFareComponent);
    });
  }
  function getDOWInNumberFormat(dow) {
    return dataUtilService.convertDayOfWeekCharacter(dow);
  }
  function getAdjustedDatesData(recommendationAdjustedDate, property, fieldOptions, rbd) {
    var adjustedDates = _.cloneDeep(_.get(recommendationAdjustedDate, property, []));
    var transformedDates = transformDates(adjustedDates, fieldOptions[property], rbd);
    return transformedDates && transformedDates.length > 0 ? transformedDates : [];
  }
  function stringToMoment(settings, adjustDate) {
    var transformedAdjustedDates = {};
    _.each(settings.fields.split(':'), function (fieldName) {
      var stringDate = adjustDate[fieldName];
      if (_.isNil(stringDate)) {
        transformedAdjustedDates[fieldName] = null;
      } else if (!momentService.isMoment(stringDate)) {
        transformedAdjustedDates[fieldName] = momentService.of(stringDate, momentService.FORMAT.DATE);
      }
    });
    return transformedAdjustedDates;
  }
  function orderValue(fieldname) {
    return function (adjustedDate) {
      if (!adjustedDate[fieldname]) {
        return -1;
      }
      return adjustedDate[fieldname].valueOf();
    };
  }
  function transformDates(adjustDates, settings, rbd) {
    var fieldnames = settings.fields.split(':');
    return _.filter(_.chain(adjustDates).map(_.partial(stringToMoment, settings)).map(_.partial(showInRange, fieldnames, getDateRange(), settings)).orderBy([orderValue(fieldnames[0]), orderValue(fieldnames[1])], ['asc', 'asc']).value(), function (adjustDate) {
      adjustDate.rbd = rbd;
      return settings.applicableDateRange ? adjustDate.isVisible : true;
    });
  }
  function showInRange(fieldNames, dateRange, settings, adjustDate) {
    if (!settings.applicableDateRange || adjustDate[fieldNames[0]] === null) {
      return adjustDate;
    }
    adjustDate.isVisible = adjustDate[fieldNames[0]].isBetween(dateRange.startDay, dateRange.endDay, 'day', '[]') || adjustDate[fieldNames[1]].isBetween(dateRange.startDay, dateRange.endDay, 'day', '[]');
    return adjustDate;
  }
  function getDateRange() {
    var startDay = momentService.now(momentService.TYPE.LOCAL_DATE);
    return {
      startDay: startDay,
      endDay: _.cloneDeep(startDay).add(FaresOptimizerConstants.CHART_MAX_DAYS, 'day')
    };
  }
  $scope.isUserAuthorizedForCurrentPos = function () {
    var pos = $scope.recommendationEntry.data.pos;
    return saveAdjustmentsService.isUserAuthorizedForCurrentPos(pos);
  };
}
AdjustDatesPanelController.$inject = ['$scope', 'MomentService', 'FaresOptimizerSaveAdjustmentsService', 'FaresOptimizerAlignFaresService', 'FaresOptimizerDataTransformerService', 'FaresOptimizerAnalysisDataUtilsService', 'FaresOptimizerSaveAdjustedFaresService', 'FaresOptimizerConstants'];
module.exports = AdjustDatesPanelController;